import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("users", "*, wishlist:wishlist(*)");

export const ProfileApi = createApi({
  reducerPath: "profile",
  baseQuery: requestBaseQuery,
  tagTypes: ["profile"],
  endpoints: (builder) => ({
    getUserProfile: builder.query({
      query: ({ filter, offset, pageLimit }) => ({
        type: "GET",
        filters: filter ?? undefined,
        offset: offset ?? 0,
        limit: pageLimit ?? 10,
      }),
      providesTags: () => [{ type: "profile" }],
    }),
    updateProfile: builder.mutation({
      query: (data) => ({ type: "PATCH", data: data, id: data.id }),
      invalidatesTags: ["profile"],
    }),
    getAllUsers: builder.query({
      query: ({ offset, pageLimit }) => ({
        type: "GET",
        offset: offset ?? 0,
        limit: pageLimit ?? 10,
      }),
      providesTags: () => [{ type: "profile" }],
    }),
  }),
});

export const { useGetUserProfileQuery, useGetAllUsersQuery , useUpdateProfileMutation , useLazyGetUserProfileQuery } =
  ProfileApi;
